import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Courses = lazy(() => import('../pages/courses/page'));
const Test = lazy(() => import('../pages/test/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Login = lazy(() => import('../pages/login/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/cursos',
    element: <Courses />,
  },
  {
    path: '/test',
    element: <Test />,
  },
  {
    path: '/nosotros',
    element: <About />,
  },
  {
    path: '/contacto',
    element: <Contact />,
  },
  {
    path: '/terminos',
    element: <Terms />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/mi-cuenta',
    element: <Dashboard />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
